import {Pipe, PipeTransform} from '@angular/core';
import {ProcessingStatus} from '../../_entities/orders/processing-statuses/processing-status';

@Pipe({
    name: 'readableStatus',
    pure: true
})
export class ReadableStatusPipe implements PipeTransform {
    transform(status: ProcessingStatus): string {
        return status.readable();
    }
}
